"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsSystemSettingsTabber = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsTabber = require("../../components/DmsTabber/DmsTabber");
var _DmsLogsSettings = require("../../components/DmsLogs/DmsLogsSettings");
var _DmsPageUploadFileSettings = require("../../pages/DmsUploadFile/DmsPageUploadFileSettings");
var _DmsLoginSettings = require("../../components/DmsLoginSettings/DmsLoginSettings");
var _DmsRemoteAuthenticatorSettings = require("../../components/DmsAuthenticatorsSettings/DmsRemoteAuthenticatorSettings");
var _DmsLdapAuthenticatorSettings = require("../../components/DmsAuthenticatorsSettings/DmsLdapAuthenticatorSettings");
var _DmsRouteList = require("../../components/DmsRouteList/DmsRouteList");
var _DmsSystemSettings = require("../../pages/DmsSystemSettings/DmsSystemSettings");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsSystemSettingsTabber is a reusable component that generates system settings tabs dynamically.
 * It includes optional tabs for Logs, Login, Upload File, Remote Authenticator, LDAP Authenticator,
 * Route List, and System settings.
 */
const DmsSystemSettingsTabber = _ref => {
  let {
    logs = true,
    login = true,
    uploadFile = true,
    remoteAuth = true,
    ldap = true,
    routeList = true,
    system = true,
    extraTabs = []
  } = _ref;
  let tabs = [];
  if (logs) {
    tabs.push({
      title: _reactIntlUniversal.default.get("Logs").d("Logs"),
      component: /*#__PURE__*/_react.default.createElement(_DmsLogsSettings.DmsLogsSettings, null)
    });
  }
  if (login) {
    tabs.push({
      title: _reactIntlUniversal.default.get("LoginSettings").d("Login Settings"),
      component: /*#__PURE__*/_react.default.createElement(_DmsLoginSettings.DmsLoginSettings, null)
    });
  }
  if (uploadFile) {
    tabs.push({
      title: _reactIntlUniversal.default.get("UploadFile").d("Upload File"),
      component: /*#__PURE__*/_react.default.createElement(_DmsPageUploadFileSettings.DmsUploadFileSettings, null)
    });
  }
  if (remoteAuth) {
    tabs.push({
      title: _reactIntlUniversal.default.get("RemoteAuthenticator").d("Remote Authenticator"),
      component: /*#__PURE__*/_react.default.createElement(_DmsRemoteAuthenticatorSettings.DmsRemoteAuthenticatorSettings, null)
    });
  }
  if (ldap) {
    tabs.push({
      title: _reactIntlUniversal.default.get("LDAPAuthenticator").d("LDAP Authenticator"),
      component: /*#__PURE__*/_react.default.createElement(_DmsLdapAuthenticatorSettings.DmsLdapAuthenticatorSettings, null)
    });
  }
  if (routeList) {
    tabs.push({
      title: _reactIntlUniversal.default.get("RouteList").d("Route List"),
      component: /*#__PURE__*/_react.default.createElement(_DmsRouteList.DmsRouteList, null)
    });
  }
  if (system) {
    tabs.push({
      title: _reactIntlUniversal.default.get("SystemSetting").d("System Setting"),
      component: /*#__PURE__*/_react.default.createElement(_DmsSystemSettings.DmsSystemSettings, null)
    });
  }
  if (Array.isArray(extraTabs) && extraTabs.length > 0) {
    tabs = [...tabs, ...extraTabs];
  }
  return /*#__PURE__*/_react.default.createElement(_DmsTabber.DmsTabber, {
    tabs: tabs
  });
};
exports.DmsSystemSettingsTabber = DmsSystemSettingsTabber;